import '../../app/config/common';
import { config } from '@abyss/ui/tools/config';
import sortBy from 'lodash/sortBy';
import { formatter } from '../../tools/formatter';
import { useQuery } from '../../tools/useQuery';

const parseResult = result => {
  const initialState = [];
  let providerName;

  if (result && result.providerOrg) {
    return sortBy(result.providerOrg, 'lastName').map(provider => {
      if (provider.firstName) {
        const firstName = formatter('capitalCase', provider.firstName);
        const lastName = formatter('capitalCase', provider.lastName);
        providerName = `${lastName}, ${firstName}`;
      } else {
        providerName = formatter('capitalCase', provider.lastName);
      }
      return {
        ...provider,
        mpin: provider.corpMpin,
        name: providerName,
        label: `${providerName} (${provider.corpMpin})`,
        uniqueId: Buffer.from(
          JSON.stringify({
            mpin: provider.corpMpin,
            id: provider.id,
          })
        ).toString('base64'),
      };
    });
  }

  return initialState;
};

export const useCorporatesSearch = options => {
  const queryOptions = options;
  const url = `${config('DS_STARGATE_API_URL')}/org/v1.0`;

  const [queryResult, queryAction] = useQuery(url, {
    ...queryOptions,
    onCompleted: result => {
      if (result.body && result.body.data) {
        queryOptions.onCompleted(parseResult(result.body.data));
      }
      queryOptions.onCompleted(parseResult(result.body));
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
